import type { JSX } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import {
  ArrowLeftIcon,
  Button,
  ChannelAvatar,
  EmptyState,
  Flex,
} from '@buffer-mono/popcorn'

import type { AccessDeniedChannel } from '~publish/components/AccessDenied'
import { allChannels } from '~publish/legacy/routes'
import { PUBLISH_UNSUPPORTED } from '~publish/utils/permissions/publishSupport'

export function PublishNotSupported({
  channel,
}: {
  channel: AccessDeniedChannel
}): JSX.Element {
  const navigate = useNavigate()
  const location = useLocation()

  const handleBack = (): void => {
    if (location.key !== 'default') {
      navigate(-1)
    } else {
      navigate(allChannels.route)
    }
  }

  return (
    <Flex align="center" justify="center" fullHeight fullWidth>
      <EmptyState size="xlarge" variant="warning">
        <ChannelAvatar
          channel={channel.service}
          src={channel.avatar ?? undefined}
          alt={channel.name}
          size="large"
        />
        <EmptyState.Heading>{PUBLISH_UNSUPPORTED}</EmptyState.Heading>
        <EmptyState.Actions>
          <Button variant="secondary" onClick={handleBack}>
            <ArrowLeftIcon /> Back
          </Button>
        </EmptyState.Actions>
      </EmptyState>
    </Flex>
  )
}
